// Import utilities
import { isDefined } from '@automator/utilities';

/**
 * Creates an unique ID
 *
 * @return {String} An unique ID
 */
const getUniqueID = () => {
	// Generate an ID
	const id = Date.now().toString( 36 ) + Math.random().toString( 36 ).substr( 2 );

	// Even though it's remote, there might be a collision, so check if this wasn't generated before
	if ( ! isDefined( window._uap_unique_hash ) ) {
		// eslint-disable-next-line camelcase
		window._uap_unique_hash = [];
	}

	// Check if this hash collides
	if ( window._uap_unique_hash.includes( id ) ) {
		// Generate another
		return getUniqueID();
	} else {
		// Save it
		window._uap_unique_hash.push( id );
	}

	return id;
};

export default getUniqueID;
